/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S2_Li5Inputs */

const en_guide_what_is_json_s2_li5 = /** @type {(inputs: Guide_What_Is_Json_S2_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Array</strong>: Ordered list of values: <code>[1, 2, 3]</code>`)
};

const ko_guide_what_is_json_s2_li5 = /** @type {(inputs: Guide_What_Is_Json_S2_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Array</strong>: 정렬된 값의 목록: <code>[1, 2, 3]</code>`)
};

const ja_guide_what_is_json_s2_li5 = /** @type {(inputs: Guide_What_Is_Json_S2_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>配列</strong>: 値の順序付きリスト：<code>[1, 2, 3]</code>`)
};

/**
* | output |
* | --- |
* | "<strong>Array</strong>: Ordered list of values: <code>[1, 2, 3]</code>" |
*
* @param {Guide_What_Is_Json_S2_Li5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s2_li5 = /** @type {((inputs?: Guide_What_Is_Json_S2_Li5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S2_Li5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s2_li5(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s2_li5(inputs)
	return ja_guide_what_is_json_s2_li5(inputs)
});